export default class AverageOrderValue{
    numberOfOrders: string;
    averageOrderValue: string;
    revenue: string;
}